import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

import { FileSelectEvent, FileUploadEvent } from 'primeng/fileupload';

import { environment } from 'src/environments/environment';
import { FincasEnvironmentDefinition } from 'src/app/view/main/2_fincas/finca/environment-variables';
import { UploadResponse } from 'src/app/common/utils';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';

@Component({
  selector: 'app-finca-pac-upload-dialog',
  standalone: false,
  templateUrl: './finca-pac-upload-dialog.component.html',
  styleUrls: ['./finca-pac-upload-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FincaPacUploadDialogComponent implements OnChanges {
  public readonly env = new FincasEnvironmentDefinition();

  @Input() public visible = false;

  @Input() public finca: FincasModel | null = null;

  @Output() public readonly visibleChange = new EventEmitter<boolean>();

  @Output() public readonly refreshRequested = new EventEmitter<void>();

  public showPACError = true;

  public txtPACError = '';

  public txtPACInfo = '';

  public urlUpload = '';

  public enableUpload = true;

  public ngOnChanges(changes: SimpleChanges): void {
    if ((changes['visible'] || changes['finca']) && this.visible) {
      this.resetMessages();
      this.prepareUploadUrl();
    }
  }

  public checkFile(event: FileSelectEvent): void {
    this.showPACError = false;
    this.txtPACError = '';

    const fileName = event.files?.[0]?.name ?? '';

    if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
      this.showPACError = true;
      this.txtPACError = 'El archivo debe ser un Excel(xlsx)';
    }
  }

  public uploaded(event: FileUploadEvent): void {
    if (!(event.originalEvent instanceof HttpResponse)) {
      return;
    }

    const response = event.originalEvent.body as UploadResponse;
    const parcelasFound = response.content_found ?? [];
    const parcelasNotFound = response.content_not_found ?? [];
    const especiesNotFound = response.especie_not_found ?? [];

    const arrayEspeciesNotFound = this.unique(especiesNotFound);
    const arrayParcelasFound = parcelasFound.map((item: ParcelasModel) => item.numero ?? '');
    const arrayParcelasNotFound = parcelasNotFound.map((item: ParcelasModel) => item.numero ?? '');

    this.showPACError = true;
    this.txtPACInfo =
      'Carga de las Parcelas realizada correctamente<br />' +
      arrayParcelasNotFound.join(', ') +
      '<br>Parcelas actualizadas<br />' +
      arrayParcelasFound.join(', ') +
      '<br/><br/>';

    if (arrayEspeciesNotFound.length === 0) {
      this.txtPACInfo += '¡Todos los Especies/Cultivos han sido encontrados! <br />';
      return;
    }

    this.txtPACError = '¡Especies/Cultivos no encontrados! <br />' + arrayEspeciesNotFound.join(', ');
  }

  public close(): void {
    this.visibleChange.emit(false);
    this.refreshRequested.emit();
  }

  public scrollToTop(): void {
    const elements = document.getElementsByClassName('ui-dialog-content ui-widget-content');

    if (!elements?.[0]) {
      return;
    }

    setTimeout(() => {
      if (elements[0]) {
        elements[0].scrollTop = 0;
      }
    }, Number('100'));
  }

  private prepareUploadUrl(): void {
    if (!this.finca?.id) {
      this.urlUpload = '';
      return;
    }

    const base = `${environment.serverUrl}ws/informes/excel_pac/fileUploadData.php`;
    const params = new URLSearchParams();

    params.set('id_finca', String(this.finca.id));

    if (this.finca.id_cliente != null) {
      params.set('id_cliente', String(this.finca.id_cliente));
    }

    const userId = this.finca.id_usuario ?? this.env.user.id;

    if (userId != null) {
      params.set('id_usuario', String(userId));
    }

    this.urlUpload = `${base}?${params.toString()}`;
  }

  private resetMessages(): void {
    this.showPACError = true;
    this.txtPACError = '';
    this.txtPACInfo = '';
    this.enableUpload = true;
  }

  private unique(array: number[]): number[] {
    return Array.from(new Set(array));
  }
}
